// Values of order are based on media queries in SCSS so we can detect the
// current breakpoint in JavaScript (see _breakpoint.scss). We do not use the
// Foundation.MediaQuery function, because it will fire several times on
// initial pageload instead of only once
const SIZES: Record<string, string> = {
  1: 'small',
  2: 'medium',
  3: 'large',
  4: 'xlarge',
  5: 'xxlarge'
};

let order: string | undefined;

/**
 * Returns the current breakpoint name
 * @param current if true, re-reads the value instead of using the cached one
 */
const breakpoint = (current = false): string => {
  if (order === undefined || current) {
    order = window.getComputedStyle(document.querySelector('.cc-breakpoint')!).getPropertyValue('order');
  }

  return SIZES[order] ?? '';
};

window.breakpoint = breakpoint;
window.breakpointInitial = breakpoint();

window.breakpointSize = {
  small: 0,
  medium: 768,
  large: 1024,
  xlarge: 1440,
  xxlarge: 1920
};

// no exports: processInclude() would invoke exported functions
export {};
